import React, { useContext, useState, useEffect } from "react";
import SocketIOContext from "./../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

import {
  Button,
  Grid,
  Typography,
  IconButton,
  TextField,
  OutlinedInput,
  InputAdornment
} from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import BackspaceIcon from "@mui/icons-material/Backspace";
import CancelIcon from "@mui/icons-material/Cancel";
import CircleButton from "./../Buttons/CircleButton";
import PhoneDisplay from "./PhoneDisplay";

import { useTheme } from "@mui/material/styles";

import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

// props has activeStep
export default function KeyboardAndPinWidget({
  errorMessageStyle,
  errorMessage,
  update,
  onEnter
}) {
  const enforceCaps = true;
  const inputTextboxFontSize = "4vh";

  const { getKioskTheme } = useContext(SocketIOContext);
  const kiosktheme = getKioskTheme();
  const theme = useTheme();

  const [keyboardState, setKeyboardState] = useState("default");
  const [keyboardRef, setKeyboardRef] = useState(null);

  const [value, setValue] = useState("");

  //Allows real keyboard changes to work
  const onChangeInput = async event => {
    const input = event.target.value;

    //if enforceCaps, set caps
    if (enforceCaps) {
      keyboardRef.setInput(input.toUpperCase());
      setValue(input.toUpperCase());
      update(input.toUpperCase());
    } else {
      keyboardRef.setInput(input);
      setValue(input);
      update(input);
    }
  };

  /* Keyboard Functions */
  const onChange = async newText => {
    console.log("onChange", newText);

    //if enforceCaps, set caps

    if (enforceCaps) {
      setValue(newText.toUpperCase());
      update(newText.toUpperCase());
    } else {
      setValue(newText);
      update(newText);
    }

    //reset french character mode
    if (
      keyboardState == "defaultcaret" ||
      keyboardState == "defaultcedilla" ||
      keyboardState == "defaultbacktick"
    ) {
      setKeyboardState("default");
    }

    if (
      keyboardState == "capscaret" ||
      keyboardState == "capscedilla" ||
      keyboardState == "capsbacktick"
    ) {
      setKeyboardState("caps");
    }

    if (keyboardState == "shiftdiaeresis") {
      setKeyboardState("default");
    }

    if (
      keyboardState == "shiftcapscaret" ||
      keyboardState == "shiftcapsdiaeresis" ||
      keyboardState == "shiftcapsbacktick"
    ) {
      setKeyboardState("shiftcaps");
    }
  };

  const onKeyPress = async button => {
    console.log("onKeyPress", button);

    if (button === "{shift}" || button === "{lock}") {
      keyboardState === "default"
        ? setKeyboardState("shift")
        : setKeyboardState("default");
    }

    switch (button) {
      case "{enter}":
        onEnter();
        break;
    }

    // switch (button) {
    //   case "{shift}":
    //     setKeyboardState("shift");
    //     break;
    //   case "{unshift}":
    //     setKeyboardState("default");
    //     break;
    //   case "{lock}":
    //   case "{shift_tocaps}":
    //     setKeyboardState("caps");
    //     break;
    //   case "{unlock}":
    //     setKeyboardState("default");
    //     break;
    //   case "{defaultcaret}":
    //     setKeyboardState("defaultcaret");
    //     break;
    //   case "{defaultcedilla}":
    //     setKeyboardState("defaultcedilla");
    //     break;
    //   case "{defaultbacktick}":
    //     setKeyboardState("defaultbacktick");
    //     break;
    //   case "{capscaret}":
    //     setKeyboardState("capscaret");
    //     break;
    //   case "{capscedilla}":
    //     setKeyboardState("capscedilla");
    //     break;
    //   case "{capsbacktick}":
    //     setKeyboardState("capsbacktick");
    //     break;
    //   case "{shiftcaps}":
    //     setKeyboardState("shiftcaps");
    //     break;
    //   case "{shiftcapscaret}":
    //     setKeyboardState("shiftcapscaret");
    //     break;
    //   case "{shiftcapsdiaeresis}":
    //     setKeyboardState("shiftcapsdiaeresis");
    //     break;
    //   case "{shiftcapsbacktick}":
    //     setKeyboardState("shiftcapsbacktick");
    //     break;
    //   case "{shiftdiaeresis}":
    //     setKeyboardState("shiftdiaeresis");
    //     break;
    //   default:
    //     if (keyboardState.startsWith("shift")) {
    //       setKeyboardState("default");
    //     }
    //     break;
    // }
  };

  const clearpress = () => {
    keyboardRef.setInput("");
    setValue("");
    update("");
  };

  return (
    <div
      id="fillout_keyanderrmessage"
      style={
        {
          // width: "100%",
          // height: "100%",
          // display: "flex",
          // alignContent: "space-between",
          // flexWrap: "wrap",
          // justifyContent: "center",
          // ...filloutStyle
        }
      }
    >
      <div id="keyboard" style={{}}>
        <OutlinedInput
          id="textbox"
          name="textbox"
          value={value}
          type="text"
          autoComplete="off"
          onChange={onChangeInput}
          style={{
            fontSize: inputTextboxFontSize,
            width: "100%",
            height: "8vh",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "2vh"
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              lineHeight: "3.19vh",
              letterSpacing: "0.021vh",
              borderRadius: "0.56vh"
            },
            "& .MuiOutlinedInput-input": {
              height: "3.19vh",
              padding: "2.23vh 1.95vh"
            }
          }}
          inputProps={{
            style: { textAlign: "center" }
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={() => {
                  clearpress();
                }}
                edge="end"
              >
                <CancelIcon style={{ fontSize: "3.8vh" }} />
              </IconButton>
            </InputAdornment>
          }
        />
        <Keyboard
          keyboardRef={r => {
            setKeyboardRef(r);
            r.setInput(value); //initialize value
          }}
          //layout={frenchlayout.layout}
          display={{
            "{bksp}": "backspace",
            "{tab}": "tab",
            "{lock}": "caps",
            "{shift}": "shift",
            "{enter}": "enter",
            "{space}": " ",
            "{}": "_",
            "{^}": "^",
            "{¸}": "¸",
            "{`}": "`",
            "{¨}": "¨",
            "{unshift}": "SHIFT",
            "{unlock}": "CAPS",
            "{defaultcaret}": "^",
            "{defaultcedilla}": "¸",
            "{defaultbacktick}": "`",
            "{capscaret}": "^",
            "{capscedilla}": "¸",
            "{capsbacktick}": "`",
            "{shiftcaps}": "shift",
            "{shiftcapscaret}": "^",
            "{shiftcapsdiaeresis}": "¨",
            "{shiftcapsbacktick}": "`",
            "{shiftdiaeresis}": "¨",
            "{shift_tocaps}": "SHIFT"
          }}
          // layout={{
          //   default: [
          //     "# 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
          //     "{tab} q w e r t y u i o p {defaultcaret} {defaultcedilla} \\",
          //     "{lock} a s d f g h j k l ; {defaultbacktick} {enter}",
          //     "{shift} z x c v b n m , . é {shift}",
          //     ".com @ {space}"
          //   ],
          //   defaultcaret: [
          //     "# 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
          //     "{tab} q w ê r t y û î ô p ^ ¸ \\",
          //     "{lock} â s d f g h j k l ; {`} {enter}",
          //     "{shift} z x c v b n m , . é {shift}",
          //     ".com @ {space}"
          //   ],
          //   defaultcedilla: [
          //     "# 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
          //     "{tab} q w e r t y u i o p ^ ¸ \\",
          //     "{lock} a s d f g h j k l ; ` {enter}",
          //     "{shift} z x ç v b n m , . é {shift}",
          //     ".com @ {space}"
          //   ],
          //   defaultbacktick: [
          //     "# 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
          //     "{tab} q w è r t y ù ì ò p ^ ¸ \\",
          //     "{lock} à s d f g h j k l ; ` {enter}",
          //     "{shift} z x c v b n m , . é {shift}",
          //     ".com @ {space}"
          //   ],
          //   caps: [
          //     '| ! " / $ % ? &amp; * ( ) _ + {bksp}',
          //     "{tab} Q W E R T Y U I O P {capscaret} {capscedilla} |",
          //     "{unlock} A S D F G H J K L : {capsbacktick} {enter}",
          //     "{shiftcaps} Z X C V B N M ' . É {shift}",
          //     ".com @ {space}"
          //   ],
          //   capscaret: [
          //     '| ! " / $ % ? &amp; * ( ) _ + {bksp}',
          //     "{tab} Q W Ê R T Y Û Î Ô P ^ ¸ |",
          //     "{unlock} Â S D F G H J K L : ` {enter}",
          //     "{shiftcaps} Z X C V B N M ' . É {shift}",
          //     ".com @ {space}"
          //   ],
          //   capscedilla: [
          //     '| ! " / $ % ? &amp; * ( ) _ + {bksp}',
          //     "{tab} Q W E R T Y U I O P ^ ¸ |",
          //     "{unlock} A S D F G H J K L : ` {enter}",
          //     "{shiftcaps} Z X C V B N M ' . É {shift}",
          //     ".com @ {space}"
          //   ],
          //   capsbacktick: [
          //     '| ! " / $ % ? &amp; * ( ) _ + {bksp}',
          //     "{tab} Q W È R T Y Ù Ì Ò P ^ ¸ |",
          //     "{unlock} À S D F G H J K L : ` {enter}",
          //     "{shiftcaps} Z X C V B N M ' . É {shift}",
          //     ".com @ {space}"
          //   ],
          //   shiftcaps: [
          //     '| ! " / $ % ? &amp; * ( ) _ + {bksp}',
          //     "{tab} Q W E R T Y U I O P {shiftcapscaret} {shiftcapsdiaeresis} |",
          //     "{unlock} A S D F G H J K L : {shiftcapsbacktick} {enter}",
          //     "{shift_tocaps} Z X C V B N M ' &gt; É {shift}",
          //     ".com @ {space}"
          //   ],
          //   shiftcapscaret: [
          //     '| ! " / $ % ? &amp; * ( ) _ + {bksp}',
          //     "{tab} Q W Ê R T Y Û Î Ô P ^ ¨ |",
          //     "{unlock} Â S D F G H J K L : ` {enter}",
          //     "{shift} Z X C V B N M ' &gt; É {shift}",
          //     ".com @ {space}"
          //   ],
          //   shiftcapsdiaeresis: [
          //     '| ! " / $ % ? &amp; * ( ) _ + {bksp}',
          //     "{tab} Q W Ë R T Y Ü Ï Ö P ^ ¨ |",
          //     "{unlock} Ä S D F G H J K L : ` {enter}",
          //     "{shift} Z X C V B N M ' &gt; É {shift}",
          //     ".com @ {space}"
          //   ],
          //   shiftcapsbacktick: [
          //     '| ! " / $ % ? &amp; * ( ) _ + {bksp}',
          //     "{tab} Q W È R T Y Ù Ì Ò P ^ ¨ |",
          //     "{unlock} À S D F G H J K L : ` {enter}",
          //     "{shift} Z X C V B N M ' &gt; É {shift}",
          //     ".com @ {space}"
          //   ],
          //   shift: [
          //     '| ! " / $ % ? &amp; * ( ) _ + {bksp}',
          //     "{tab} Q W E R T Y U I O P {defaultcaret} {shiftdiaeresis} |",
          //     "{lock} A S D F G H J K L : {defaultbacktick} {enter}",
          //     "{unshift} Z X C V B N M ' &gt; É {shift}",
          //     ".com @ {space}"
          //   ],
          //   shiftdiaeresis: [
          //     "# 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
          //     "{tab} q w ë r t ÿ ü ï ö p {^} [¨] \\",
          //     "{lock} ä s d f g h j k l ; {`} {enter}",
          //     "{shift} z x c v b n m , . é {shift}",
          //     ".com @ {space}"
          //   ],
          //   alt: [
          //     " ± @ £ ¢ ¤ ¬ ¦ ² ³ ¼ ½ ¾ } {bksp}",
          //     "{tab} Q W E R T Y U I § ¶ [ ] |",
          //     "{lock} A S D F G H J K L ~ { {enter}",
          //     "{shift} Z X C V B N µ ¯ ´ {´} {shift}",
          //     ".com @ {space}"
          //   ]
          // }}
          layout={{
            default: [
              "1 2 3 4 5 6 7 8 9 0 {bksp}",
              "Q W E R T Y U I O P",
              "A S D F G H J K L {enter}",
              "Z X C V B N M"
            ]
          }}
          theme={"hg-theme-default hg-layout-default myTheme"}
          layoutName={keyboardState}
          onChange={onChange}
          onKeyPress={onKeyPress}
          tabCharOnTab="false"
          inputPattern={"/^[a-zA-Z]+$/"} //Not currently working???
        />
      </div>
      <div id="phoneerror">
        <Typography variant="body2" style={errorMessageStyle}>
          {errorMessage}
        </Typography>
      </div>
    </div>
  );
}
